import styled from "@emotion/styled";

const Icons = `
  .tpd-icon {
    margin-left: -8px;
    float: left;
    font-size: 26px;
    line-height: 26px;
    font-family: Unipol Bold;
    color: #fff;
  }
`;

export const ContainerDiv = styled.div<{
  goBack: boolean;
  textLink: string;
  isEditmode: boolean;
}>`
  display: ${(props) =>
    (props.goBack && props.textLink !== "") || props.isEditmode
      ? "block"
      : "none"};
  width: 100%;
  height: 100%;
  background-color: #193a56;

  ${Icons}
`;

export const TpdTastoIndietroContainer = styled.div`
  overflow: hidden;
  width: 100%;
  max-width: 1280px;
  height: 100%;
  margin: auto;
  padding-top: 39px;
`;

export const TpdTastoIndietroContent = styled.div<{ offset: string }>`
  display: block;
  width: 100%;
  height: 33px;
  margin-left: ${(props) =>
    props.offset === "medium offset" ? "8.3" : "4.3"}%;
`;

export const TpdGoBack = styled.div`
  .tpd-short-text-container {
    justify-content: start;
    color: #fff;

    .tpd-short-text-preview-mode-container {
      transition: all 0.25s ease-out 0s;
      text-decoration: underline;
      font-family: Unipol Bold;
      font-size: 16px;
      cursor: pointer;
    }

    .tpd-short-text-preview-mode-container:hover {
      color: #fff;
      opacity: 0.8;
    }
    .tpd-short-text-edit-mode-container {
      textarea {
        text-decoration: underline;
        font-family: Unipol Bold;
        font-size: 16px;
        cursor: pointer;
      }
    }
  }
`;
